import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { useAtomValue } from "jotai";
import { currentTheme } from "../atoms";
import React, { useMemo } from "react";
import { createMuiTheme } from "../theme/appTheme";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  const theme = useAtomValue(currentTheme);
  const muiTheme = useMemo(() => createMuiTheme(theme), [theme]);
  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>;
};
